export default __webpack_public_path__ + "static/media/play.e8400429.svg";